import { render, staticRenderFns } from "./form.vue?vue&type=template&id=a2a4ff30"
import script from "./form.vue?vue&type=script&lang=js"
export * from "./form.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("E:\\xc\\integrated-business-and-finance-wechat\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('a2a4ff30')) {
      api.createRecord('a2a4ff30', component.options)
    } else {
      api.reload('a2a4ff30', component.options)
    }
    module.hot.accept("./form.vue?vue&type=template&id=a2a4ff30", function () {
      api.rerender('a2a4ff30', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/purchase/form.vue"
export default component.exports